import { Authorization, AuthTokenInfo, AuthUserInfo } from '../models';

import { AuthTokenService } from './interfaces/auth-token.service';

export class JsonWebTokenService implements AuthTokenService {

  public getInfo(token: string): AuthTokenInfo {
    const payload = this.decodePayload(token);
    return {
      user: this.getUserInfoFromPayload(payload),
      authorization: this.getAuthorizationFromPayload(payload),
      expirationDate: this.getExpirationDateFromPayload(payload)
    };
  }

  public isExpired(token: string): boolean {
    const payload = this.decodePayload(token);
    const expirationDate = this.getExpirationDateFromPayload(payload);
    return (!expirationDate || (expirationDate.getTime() <= Date.now()));
  }

  public isNearToExpire(token: string, marginInMillis: number): boolean {
    const payload = this.decodePayload(token);
    const expirationDate = this.getExpirationDateFromPayload(payload);
    if (!!expirationDate) {
      const expirationDateInMillis = expirationDate.getTime();
      const now = Date.now();
      return ((expirationDateInMillis > now) && (expirationDateInMillis < (now + marginInMillis)));
    }
  }

  private decodePayload(token: string) { // https://stackoverflow.com/a/38552302
    try {
      const base64Payload = token.split('.')[1]
        .replace('-', '+')
        .replace('_', '/');
      const jsonPayload = decodeURIComponent(
        atob(base64Payload)
          .split('')
          .map((char: string) => `%${ `00${ char.charCodeAt(0).toString(16) }`.slice(-2) }`)
          .join('')
      );
      return JSON.parse(jsonPayload);
    } catch (error) {
      return {};
    }
  }

  private getUserInfoFromPayload(payload): AuthUserInfo {
    return {
      id: payload['eb::id'],
      name: payload['sub'],
      firstName: payload['first_name'],
      lastName: payload['last_name']
    };
  }

  private getAuthorizationFromPayload(payload): Authorization {
    const roles: { [role: string]: string[] } = (payload['eb::roles'] || {});
    return Object.entries(roles).reduce((authorization: Authorization, [role, instanceIds]: [string, string[]]) => {
      instanceIds.forEach((instanceId: string) => {
        if (!authorization[instanceId]) {
          authorization[instanceId] = [];
        }
        authorization[instanceId].push(role);
      });
      return authorization;
    }, {});
  }

  private getExpirationDateFromPayload(payload): Date {
    const expirationDateInSeconds: number = payload['exp'];
    if ((expirationDateInSeconds !== undefined) && (expirationDateInSeconds !== null)) {
      return new Date(expirationDateInSeconds * 1000);
    }
  }

}
